import { Component, OnInit } from '@angular/core';
import { TimeUtils } from 'src/common/timeUtils';
import { Deploy, deploys } from './about';

@Component({
	selector: 'app-about',
	templateUrl: './about.component.html',
	styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

	deploys: Deploy[] = deploys;


	constructor( private timeUtils: TimeUtils ) {
	}

	ngOnInit() {
	}

	getDateAsShortString( date: Date ) {
		return this.timeUtils.getDateAsShortString( date );
	}

}
